<div id="interactions" [innerHTML]="htmlContent|safeHtml"></div>
